import Animation from '../../animations/remove-breakdown-animation'
import StyleTweeners from '../style-tweeners'
import { EPSILON } from 'chart-constants'

class RemoveBreakdownAnimation extends Animation {

  constructor (options) {
    super(options)
    this.styleTweeners = new StyleTweeners(this.styles)
  }

  animate (serie, entering, selection, merged, exiting) {
    // The points are hidden because it's an area chart, let's show them
    // but set their opacity so we can fade them in
    selection.selectAll('.point')
             .style('display', 'block')
             .style('opacity', EPSILON)

    super.animate(serie, entering, selection, merged, exiting)

    merged.selectAll('.point')
          .style('opacity', 1)

    merged.tween('fade-out', this.styleTweeners.fadeOut(merged, false, .50))
          .tween('grow-stroke', this.styleTweeners.growStroke(merged))
  }

}

export default RemoveBreakdownAnimation
